import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var GlobalParticipantType = /*#__PURE__*/function (GlobalParticipantType) {
  GlobalParticipantType[GlobalParticipantType["GLOBAL_PARTICIPANT_TYPE_UNDEFINED"] = 0] = "GLOBAL_PARTICIPANT_TYPE_UNDEFINED";
  GlobalParticipantType[GlobalParticipantType["GLOBAL_PARTICIPANT_TYPE_CUSTOMER"] = 1] = "GLOBAL_PARTICIPANT_TYPE_CUSTOMER";
  GlobalParticipantType[GlobalParticipantType["GLOBAL_PARTICIPANT_TYPE_IAM_USER"] = 2] = "GLOBAL_PARTICIPANT_TYPE_IAM_USER";
  GlobalParticipantType[GlobalParticipantType["GLOBAL_PARTICIPANT_TYPE_ACCOUNT_GROUP"] = 3] = "GLOBAL_PARTICIPANT_TYPE_ACCOUNT_GROUP";
  GlobalParticipantType[GlobalParticipantType["GLOBAL_PARTICIPANT_TYPE_PARTNER"] = 4] = "GLOBAL_PARTICIPANT_TYPE_PARTNER";
  GlobalParticipantType[GlobalParticipantType["GLOBAL_PARTICIPANT_TYPE_IAM_TEMPORARY_SUBJECT"] = 5] = "GLOBAL_PARTICIPANT_TYPE_IAM_TEMPORARY_SUBJECT";
  GlobalParticipantType[GlobalParticipantType["GLOBAL_PARTICIPANT_TYPE_DIGITAL_AGENT"] = 6] = "GLOBAL_PARTICIPANT_TYPE_DIGITAL_AGENT";
  GlobalParticipantType[GlobalParticipantType["GLOBAL_PARTICIPANT_TYPE_VENDOR"] = 7] = "GLOBAL_PARTICIPANT_TYPE_VENDOR";
  GlobalParticipantType[GlobalParticipantType["GLOBAL_PARTICIPANT_TYPE_OPENAI_BOT"] = 8] = "GLOBAL_PARTICIPANT_TYPE_OPENAI_BOT";
  GlobalParticipantType[GlobalParticipantType["GLOBAL_PARTICIPANT_TYPE_ANONYMOUS"] = 9] = "GLOBAL_PARTICIPANT_TYPE_ANONYMOUS";
  GlobalParticipantType[GlobalParticipantType["GLOBAL_PARTICIPANT_TYPE_GROUP"] = 10] = "GLOBAL_PARTICIPANT_TYPE_GROUP";
  return GlobalParticipantType;
}(GlobalParticipantType || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 0] = "SORT_DIRECTION_DESCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  return SortDirection;
}(SortDirection || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ConversationChannel = /*#__PURE__*/function (ConversationChannel) {
  ConversationChannel[ConversationChannel["CONVERSATION_CHANNEL_UNDEFINED"] = 0] = "CONVERSATION_CHANNEL_UNDEFINED";
  ConversationChannel[ConversationChannel["CONVERSATION_CHANNEL_INTERNAL"] = 1] = "CONVERSATION_CHANNEL_INTERNAL";
  ConversationChannel[ConversationChannel["CONVERSATION_CHANNEL_SMS"] = 2] = "CONVERSATION_CHANNEL_SMS";
  ConversationChannel[ConversationChannel["CONVERSATION_CHANNEL_FACEBOOK"] = 3] = "CONVERSATION_CHANNEL_FACEBOOK";
  ConversationChannel[ConversationChannel["CONVERSATION_CHANNEL_GOOGLE_MESSAGES"] = 4] = "CONVERSATION_CHANNEL_GOOGLE_MESSAGES";
  ConversationChannel[ConversationChannel["CONVERSATION_CHANNEL_OPENAI"] = 5] = "CONVERSATION_CHANNEL_OPENAI";
  ConversationChannel[ConversationChannel["CONVERSATION_CHANNEL_EMAIL"] = 6] = "CONVERSATION_CHANNEL_EMAIL";
  ConversationChannel[ConversationChannel["CONVERSATION_CHANNEL_GOOGLE_BUSINESS_COMMUNICATIONS"] = 7] = "CONVERSATION_CHANNEL_GOOGLE_BUSINESS_COMMUNICATIONS";
  ConversationChannel[ConversationChannel["CONVERSATION_CHANNEL_WEB_CHAT"] = 8] = "CONVERSATION_CHANNEL_WEB_CHAT";
  return ConversationChannel;
}(ConversationChannel || {});
var PlatformLocation = /*#__PURE__*/function (PlatformLocation) {
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_UNDEFINED"] = 0] = "PLATFORM_LOCATION_UNDEFINED";
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_BUSINESS_APP"] = 1] = "PLATFORM_LOCATION_BUSINESS_APP";
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_PARTNER_CENTER"] = 2] = "PLATFORM_LOCATION_PARTNER_CENTER";
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_VENDOR_CENTER"] = 3] = "PLATFORM_LOCATION_VENDOR_CENTER";
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_TASK_MANAGER"] = 4] = "PLATFORM_LOCATION_TASK_MANAGER";
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_PROPOSAL_BUILDER"] = 5] = "PLATFORM_LOCATION_PROPOSAL_BUILDER";
  PlatformLocation[PlatformLocation["PLATFORM_LOCATION_SALES_CENTER"] = 6] = "PLATFORM_LOCATION_SALES_CENTER";
  return PlatformLocation;
}(PlatformLocation || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MessageStatus = /*#__PURE__*/function (MessageStatus) {
  MessageStatus[MessageStatus["MESSAGE_STATUS_NOT_READ"] = 0] = "MESSAGE_STATUS_NOT_READ";
  MessageStatus[MessageStatus["MESSAGE_STATUS_READ"] = 1] = "MESSAGE_STATUS_READ";
  MessageStatus[MessageStatus["MESSAGE_STATUS_SENT"] = 2] = "MESSAGE_STATUS_SENT";
  MessageStatus[MessageStatus["MESSAGE_STATUS_DELIVERED"] = 3] = "MESSAGE_STATUS_DELIVERED";
  MessageStatus[MessageStatus["MESSAGE_STATUS_FAILED"] = 4] = "MESSAGE_STATUS_FAILED";
  MessageStatus[MessageStatus["MESSAGE_STATUS_UNDELIVERED"] = 5] = "MESSAGE_STATUS_UNDELIVERED";
  MessageStatus[MessageStatus["MESSAGE_STATUS_SENDING"] = 6] = "MESSAGE_STATUS_SENDING";
  return MessageStatus;
}(MessageStatus || {});
var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType[MessageType["MESSAGE_TYPE_MESSAGE"] = 0] = "MESSAGE_TYPE_MESSAGE";
  MessageType[MessageType["MESSAGE_TYPE_MEDIA"] = 1] = "MESSAGE_TYPE_MEDIA";
  MessageType[MessageType["MESSAGE_TYPE_SYSTEM"] = 2] = "MESSAGE_TYPE_SYSTEM";
  return MessageType;
}(MessageType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ParticipantType = /*#__PURE__*/function (ParticipantType) {
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_UNDEFINED"] = 0] = "PARTICIPANT_TYPE_UNDEFINED";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_CUSTOMER"] = 1] = "PARTICIPANT_TYPE_CUSTOMER";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_IAM_USER"] = 2] = "PARTICIPANT_TYPE_IAM_USER";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_ACCOUNT_GROUP"] = 3] = "PARTICIPANT_TYPE_ACCOUNT_GROUP";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_PARTNER"] = 4] = "PARTICIPANT_TYPE_PARTNER";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_IAM_TEMPORARY_SUBJECT"] = 5] = "PARTICIPANT_TYPE_IAM_TEMPORARY_SUBJECT";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_DIGITAL_AGENT"] = 6] = "PARTICIPANT_TYPE_DIGITAL_AGENT";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_VENDOR"] = 7] = "PARTICIPANT_TYPE_VENDOR";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_OPENAI_BOT"] = 8] = "PARTICIPANT_TYPE_OPENAI_BOT";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_ANONYMOUS"] = 9] = "PARTICIPANT_TYPE_ANONYMOUS";
  ParticipantType[ParticipantType["PARTICIPANT_TYPE_GROUP"] = 10] = "PARTICIPANT_TYPE_GROUP";
  return ParticipantType;
}(ParticipantType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ViewType = /*#__PURE__*/function (ViewType) {
  ViewType[ViewType["VIEW_TYPE_UNDEFINED"] = 0] = "VIEW_TYPE_UNDEFINED";
  ViewType[ViewType["VIEW_TYPE_FOLLOWING"] = 1] = "VIEW_TYPE_FOLLOWING";
  return ViewType;
}(ViewType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var WidgetPosition = /*#__PURE__*/function (WidgetPosition) {
  WidgetPosition[WidgetPosition["WIDGET_POSITION_UNSPECIFIED"] = 0] = "WIDGET_POSITION_UNSPECIFIED";
  WidgetPosition[WidgetPosition["WIDGET_POSITION_RIGHT"] = 1] = "WIDGET_POSITION_RIGHT";
  WidgetPosition[WidgetPosition["WIDGET_POSITION_LEFT"] = 2] = "WIDGET_POSITION_LEFT";
  return WidgetPosition;
}(WidgetPosition || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var EvaluationSentiment = /*#__PURE__*/function (EvaluationSentiment) {
  EvaluationSentiment[EvaluationSentiment["EVALUATION_SENTIMENT_UNDEFINED"] = 0] = "EVALUATION_SENTIMENT_UNDEFINED";
  EvaluationSentiment[EvaluationSentiment["EVALUATION_SENTIMENT_POSITIVE"] = 1] = "EVALUATION_SENTIMENT_POSITIVE";
  EvaluationSentiment[EvaluationSentiment["EVALUATION_SENTIMENT_NEGATIVE"] = 2] = "EVALUATION_SENTIMENT_NEGATIVE";
  return EvaluationSentiment;
}(EvaluationSentiment || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MetadataIdentifier = /*#__PURE__*/function (MetadataIdentifier) {
  MetadataIdentifier[MetadataIdentifier["METADATA_IDENTIFIER_UNDEFINED"] = 0] = "METADATA_IDENTIFIER_UNDEFINED";
  MetadataIdentifier[MetadataIdentifier["METADATA_IDENTIFIER_RECIPIENT"] = 1] = "METADATA_IDENTIFIER_RECIPIENT";
  MetadataIdentifier[MetadataIdentifier["METADATA_IDENTIFIER_SENDER"] = 2] = "METADATA_IDENTIFIER_SENDER";
  MetadataIdentifier[MetadataIdentifier["METADATA_IDENTIFIER_CONVERSATION"] = 3] = "METADATA_IDENTIFIER_CONVERSATION";
  return MetadataIdentifier;
}(MetadataIdentifier || {});
var SetLastSeenRequestStatus = /*#__PURE__*/function (SetLastSeenRequestStatus) {
  SetLastSeenRequestStatus[SetLastSeenRequestStatus["SET_LAST_SEEN_REQUEST_STATUS_READ"] = 0] = "SET_LAST_SEEN_REQUEST_STATUS_READ";
  SetLastSeenRequestStatus[SetLastSeenRequestStatus["SET_LAST_SEEN_REQUEST_STATUS_UNREAD"] = 1] = "SET_LAST_SEEN_REQUEST_STATUS_UNREAD";
  return SetLastSeenRequestStatus;
}(SetLastSeenRequestStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class NamespaceDetail {
  static fromProto(proto) {
    let m = new NamespaceDetail();
    m = Object.assign(m, proto);
    if (proto.participantType) {
      m.participantType = enumStringToValue$a(GlobalParticipantType, proto.participantType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participantType !== 'undefined') {
      toReturn['participantType'] = this.participantType;
    }
    if (typeof this.internalParticipantId !== 'undefined') {
      toReturn['internalParticipantId'] = this.internalParticipantId;
    }
    return toReturn;
  }
}
class SubjectParticipant {
  static fromProto(proto) {
    let m = new SubjectParticipant();
    m = Object.assign(m, proto);
    if (proto.participantType) {
      m.participantType = enumStringToValue$a(GlobalParticipantType, proto.participantType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participantType !== 'undefined') {
      toReturn['participantType'] = this.participantType;
    }
    if (typeof this.internalParticipantId !== 'undefined') {
      toReturn['internalParticipantId'] = this.internalParticipantId;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Conversation {
  static fromProto(proto) {
    let m = new Conversation();
    m = Object.assign(m, proto);
    if (proto.channel) {
      m.channel = enumStringToValue$9(ConversationChannel, proto.channel);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.latestMsgSentTime) {
      m.latestMsgSentTime = new Date(proto.latestMsgSentTime);
    }
    if (proto.originLocation) {
      m.originLocation = enumStringToValue$9(PlatformLocation, proto.originLocation);
    }
    if (proto.lastSeenByParticipant) {
      m.lastSeenByParticipant = proto.lastSeenByParticipant.map(LastSeenByParticipant.fromProto);
    }
    if (proto.subjectParticipants) {
      m.subjectParticipants = proto.subjectParticipants.map(SubjectParticipant.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    if (typeof this.externalConversationId !== 'undefined') {
      toReturn['externalConversationId'] = this.externalConversationId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.participantIds !== 'undefined') {
      toReturn['participantIds'] = this.participantIds;
    }
    if (typeof this.latestMsgSentTime !== 'undefined' && this.latestMsgSentTime !== null) {
      toReturn['latestMsgSentTime'] = 'toApiJson' in this.latestMsgSentTime ? this.latestMsgSentTime.toApiJson() : this.latestMsgSentTime;
    }
    if (typeof this.originLocation !== 'undefined') {
      toReturn['originLocation'] = this.originLocation;
    }
    if (typeof this.originLocationExternalId !== 'undefined') {
      toReturn['originLocationExternalId'] = this.originLocationExternalId;
    }
    if (typeof this.lastSeenByParticipant !== 'undefined' && this.lastSeenByParticipant !== null) {
      toReturn['lastSeenByParticipant'] = 'toApiJson' in this.lastSeenByParticipant ? this.lastSeenByParticipant.toApiJson() : this.lastSeenByParticipant;
    }
    if (typeof this.conversationViewIds !== 'undefined') {
      toReturn['conversationViewIds'] = this.conversationViewIds;
    }
    if (typeof this.subjectParticipantsKey !== 'undefined') {
      toReturn['subjectParticipantsKey'] = this.subjectParticipantsKey;
    }
    if (typeof this.subjectParticipants !== 'undefined' && this.subjectParticipants !== null) {
      toReturn['subjectParticipants'] = 'toApiJson' in this.subjectParticipants ? this.subjectParticipants.toApiJson() : this.subjectParticipants;
    }
    if (typeof this.isOpen !== 'undefined') {
      toReturn['isOpen'] = this.isOpen;
    }
    return toReturn;
  }
}
class ConversationKey {
  static fromProto(proto) {
    let m = new ConversationKey();
    m = Object.assign(m, proto);
    if (proto.subjectParticipants) {
      m.subjectParticipants = proto.subjectParticipants.map(SubjectParticipant.fromProto);
    }
    if (proto.channel) {
      m.channel = enumStringToValue$9(ConversationChannel, proto.channel);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectParticipants !== 'undefined' && this.subjectParticipants !== null) {
      toReturn['subjectParticipants'] = 'toApiJson' in this.subjectParticipants ? this.subjectParticipants.toApiJson() : this.subjectParticipants;
    }
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    if (typeof this.originLocationExternalId !== 'undefined') {
      toReturn['originLocationExternalId'] = this.originLocationExternalId;
    }
    return toReturn;
  }
}
class LastSeenByParticipant {
  static fromProto(proto) {
    let m = new LastSeenByParticipant();
    m = Object.assign(m, proto);
    if (proto.lastSeenTime) {
      m.lastSeenTime = new Date(proto.lastSeenTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participantId !== 'undefined') {
      toReturn['participantId'] = this.participantId;
    }
    if (typeof this.lastSeenTime !== 'undefined' && this.lastSeenTime !== null) {
      toReturn['lastSeenTime'] = 'toApiJson' in this.lastSeenTime ? this.lastSeenTime.toApiJson() : this.lastSeenTime;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Message {
  static fromProto(proto) {
    let m = new Message();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$8(MessageType, proto.type);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.sendStatus) {
      m.sendStatus = SendStatus.fromProto(proto.sendStatus);
    }
    if (proto.channel) {
      m.channel = enumStringToValue$8(ConversationChannel, proto.channel);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    if (typeof this.externalMessageId !== 'undefined') {
      toReturn['externalMessageId'] = this.externalMessageId;
    }
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.participantId !== 'undefined') {
      toReturn['participantId'] = this.participantId;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.error !== 'undefined') {
      toReturn['error'] = this.error;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.media !== 'undefined') {
      toReturn['media'] = this.media;
    }
    if (typeof this.sendStatus !== 'undefined' && this.sendStatus !== null) {
      toReturn['sendStatus'] = 'toApiJson' in this.sendStatus ? this.sendStatus.toApiJson() : this.sendStatus;
    }
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    return toReturn;
  }
}
class ParticipantMessageStatus {
  static fromProto(proto) {
    let m = new ParticipantMessageStatus();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$8(MessageStatus, proto.status);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participantId !== 'undefined') {
      toReturn['participantId'] = this.participantId;
    }
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class SendStatus {
  static fromProto(proto) {
    let m = new SendStatus();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$8(MessageStatus, proto.status);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Address {
  static fromProto(proto) {
    let m = new Address();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstLineAddress !== 'undefined') {
      toReturn['firstLineAddress'] = this.firstLineAddress;
    }
    if (typeof this.secondLineAddress !== 'undefined') {
      toReturn['secondLineAddress'] = this.secondLineAddress;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.zipCode !== 'undefined') {
      toReturn['zipCode'] = this.zipCode;
    }
    return toReturn;
  }
}
class Participant {
  static fromProto(proto) {
    let m = new Participant();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = enumStringToValue$7(PlatformLocation, proto.location);
    }
    if (proto.channel) {
      m.channel = enumStringToValue$7(ConversationChannel, proto.channel);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.participantType) {
      m.participantType = enumStringToValue$7(ParticipantType, proto.participantType);
    }
    if (proto.address) {
      m.address = Address.fromProto(proto.address);
    }
    if (proto.namespaceHierarchy) {
      m.namespaceHierarchy = proto.namespaceHierarchy.map(NamespaceDetail.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participantId !== 'undefined') {
      toReturn['participantId'] = this.participantId;
    }
    if (typeof this.internalParticipantId !== 'undefined') {
      toReturn['internalParticipantId'] = this.internalParticipantId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    if (typeof this.externalParticipantId !== 'undefined') {
      toReturn['externalParticipantId'] = this.externalParticipantId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.participantType !== 'undefined') {
      toReturn['participantType'] = this.participantType;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.address !== 'undefined' && this.address !== null) {
      toReturn['address'] = 'toApiJson' in this.address ? this.address.toApiJson() : this.address;
    }
    if (typeof this.isSubjectParticipant !== 'undefined') {
      toReturn['isSubjectParticipant'] = this.isSubjectParticipant;
    }
    if (typeof this.isParticipantInternalInfoDeleted !== 'undefined') {
      toReturn['isParticipantInternalInfoDeleted'] = this.isParticipantInternalInfoDeleted;
    }
    if (typeof this.profileImageUrl !== 'undefined') {
      toReturn['profileImageUrl'] = this.profileImageUrl;
    }
    if (typeof this.namespaceHierarchy !== 'undefined' && this.namespaceHierarchy !== null) {
      toReturn['namespaceHierarchy'] = 'toApiJson' in this.namespaceHierarchy ? this.namespaceHierarchy.toApiJson() : this.namespaceHierarchy;
    }
    return toReturn;
  }
}
class ParticipantKey {
  static fromProto(proto) {
    let m = new ParticipantKey();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = enumStringToValue$7(PlatformLocation, proto.location);
    }
    if (proto.channels) {
      m.channels = proto.channels.map(v => enumStringToValue$7(ConversationChannel, v));
    }
    if (proto.participantType) {
      m.participantType = enumStringToValue$7(GlobalParticipantType, proto.participantType);
    }
    if (proto.namespaceHierarchy) {
      m.namespaceHierarchy = proto.namespaceHierarchy.map(NamespaceDetail.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.internalParticipantId !== 'undefined') {
      toReturn['internalParticipantId'] = this.internalParticipantId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.channels !== 'undefined') {
      toReturn['channels'] = this.channels;
    }
    if (typeof this.participantType !== 'undefined') {
      toReturn['participantType'] = this.participantType;
    }
    if (typeof this.namespaceHierarchy !== 'undefined' && this.namespaceHierarchy !== null) {
      toReturn['namespaceHierarchy'] = 'toApiJson' in this.namespaceHierarchy ? this.namespaceHierarchy.toApiJson() : this.namespaceHierarchy;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Configuration {
  static fromProto(proto) {
    let m = new Configuration();
    m = Object.assign(m, proto);
    if (proto.subjectParticipant) {
      m.subjectParticipant = SubjectParticipant.fromProto(proto.subjectParticipant);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.updatedAt) {
      m.updatedAt = new Date(proto.updatedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectParticipant !== 'undefined' && this.subjectParticipant !== null) {
      toReturn['subjectParticipant'] = 'toApiJson' in this.subjectParticipant ? this.subjectParticipant.toApiJson() : this.subjectParticipant;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    if (typeof this.updatedAt !== 'undefined' && this.updatedAt !== null) {
      toReturn['updatedAt'] = 'toApiJson' in this.updatedAt ? this.updatedAt.toApiJson() : this.updatedAt;
    }
    if (typeof this.availabilityMessage !== 'undefined') {
      toReturn['availabilityMessage'] = this.availabilityMessage;
    }
    if (typeof this.showAvailabilityMessage !== 'undefined') {
      toReturn['showAvailabilityMessage'] = this.showAvailabilityMessage;
    }
    if (typeof this.googleBusinessMessagesEnabled !== 'undefined') {
      toReturn['googleBusinessMessagesEnabled'] = this.googleBusinessMessagesEnabled;
    }
    if (typeof this.smsEnabled !== 'undefined') {
      toReturn['smsEnabled'] = this.smsEnabled;
    }
    if (typeof this.inboxProEnabled !== 'undefined') {
      toReturn['inboxProEnabled'] = this.inboxProEnabled;
    }
    if (typeof this.webChatEnabled !== 'undefined') {
      toReturn['webChatEnabled'] = this.webChatEnabled;
    }
    if (typeof this.facebookMessengerEnabled !== 'undefined') {
      toReturn['facebookMessengerEnabled'] = this.facebookMessengerEnabled;
    }
    if (typeof this.multiLocationEnabled !== 'undefined') {
      toReturn['multiLocationEnabled'] = this.multiLocationEnabled;
    }
    return toReturn;
  }
}
class ProductFeature {
  static fromProto(proto) {
    let m = new ProductFeature();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleBusinessMessagesEnabled !== 'undefined') {
      toReturn['googleBusinessMessagesEnabled'] = this.googleBusinessMessagesEnabled;
    }
    if (typeof this.smsEnabled !== 'undefined') {
      toReturn['smsEnabled'] = this.smsEnabled;
    }
    if (typeof this.multiLocationEnabled !== 'undefined') {
      toReturn['multiLocationEnabled'] = this.multiLocationEnabled;
    }
    if (typeof this.webChatEnabled !== 'undefined') {
      toReturn['webChatEnabled'] = this.webChatEnabled;
    }
    if (typeof this.facebookMessengerEnabled !== 'undefined') {
      toReturn['facebookMessengerEnabled'] = this.facebookMessengerEnabled;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class View {
  static fromProto(proto) {
    let m = new View();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.viewId !== 'undefined') {
      toReturn['viewId'] = this.viewId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DataSources {
  static fromProto(proto) {
    let m = new DataSources();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessProfile !== 'undefined') {
      toReturn['businessProfile'] = this.businessProfile;
    }
    return toReturn;
  }
}
class Widget {
  static fromProto(proto) {
    let m = new Widget();
    m = Object.assign(m, proto);
    if (proto.position) {
      m.position = enumStringToValue$3(WidgetPosition, proto.position);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.color !== 'undefined') {
      toReturn['color'] = this.color;
    }
    if (typeof this.allowedUrls !== 'undefined') {
      toReturn['allowedUrls'] = this.allowedUrls;
    }
    if (typeof this.position !== 'undefined') {
      toReturn['position'] = this.position;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.isEnabled !== 'undefined') {
      toReturn['isEnabled'] = this.isEnabled;
    }
    if (typeof this.welcomeMessage !== 'undefined') {
      toReturn['welcomeMessage'] = this.welcomeMessage;
    }
    if (typeof this.textColor !== 'undefined') {
      toReturn['textColor'] = this.textColor;
    }
    if (typeof this.accentColor !== 'undefined') {
      toReturn['accentColor'] = this.accentColor;
    }
    if (typeof this.accentTextColor !== 'undefined') {
      toReturn['accentTextColor'] = this.accentTextColor;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class MessageTemplate {
  static fromProto(proto) {
    let m = new MessageTemplate();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddConversationToConversationViewRequest {
  static fromProto(proto) {
    let m = new AddConversationToConversationViewRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.viewId !== 'undefined') {
      toReturn['viewId'] = this.viewId;
    }
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.participantId !== 'undefined') {
      toReturn['participantId'] = this.participantId;
    }
    return toReturn;
  }
}
class AddMultiParticipantsRequest {
  static fromProto(proto) {
    let m = new AddMultiParticipantsRequest();
    m = Object.assign(m, proto);
    if (proto.participants) {
      m.participants = proto.participants.map(Participant.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.participants !== 'undefined' && this.participants !== null) {
      toReturn['participants'] = 'toApiJson' in this.participants ? this.participants.toApiJson() : this.participants;
    }
    return toReturn;
  }
}
class AddMultiParticipantsResponse {
  static fromProto(proto) {
    let m = new AddMultiParticipantsResponse();
    m = Object.assign(m, proto);
    if (proto.participants) {
      m.participants = proto.participants.map(Participant.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participants !== 'undefined' && this.participants !== null) {
      toReturn['participants'] = 'toApiJson' in this.participants ? this.participants.toApiJson() : this.participants;
    }
    return toReturn;
  }
}
class ConversationMessageCount {
  static fromProto(proto) {
    let m = new ConversationMessageCount();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class LookupConversationsResponseConversations {
  static fromProto(proto) {
    let m = new LookupConversationsResponseConversations();
    m = Object.assign(m, proto);
    if (proto.conversation) {
      m.conversation = Conversation.fromProto(proto.conversation);
    }
    if (proto.participants) {
      m.participants = proto.participants.map(Participant.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversation !== 'undefined' && this.conversation !== null) {
      toReturn['conversation'] = 'toApiJson' in this.conversation ? this.conversation.toApiJson() : this.conversation;
    }
    if (typeof this.participants !== 'undefined' && this.participants !== null) {
      toReturn['participants'] = 'toApiJson' in this.participants ? this.participants.toApiJson() : this.participants;
    }
    return toReturn;
  }
}
class GetMultiConversationMessageCountResponseCountsEntry {
  static fromProto(proto) {
    let m = new GetMultiConversationMessageCountResponseCountsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class CreateConversationRequest {
  static fromProto(proto) {
    let m = new CreateConversationRequest();
    m = Object.assign(m, proto);
    if (proto.participants) {
      m.participants = proto.participants.map(Participant.fromProto);
    }
    if (proto.channel) {
      m.channel = enumStringToValue(ConversationChannel, proto.channel);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.originLocation) {
      m.originLocation = enumStringToValue(PlatformLocation, proto.originLocation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participants !== 'undefined' && this.participants !== null) {
      toReturn['participants'] = 'toApiJson' in this.participants ? this.participants.toApiJson() : this.participants;
    }
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    if (typeof this.externalConversationId !== 'undefined') {
      toReturn['externalConversationId'] = this.externalConversationId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.originLocation !== 'undefined') {
      toReturn['originLocation'] = this.originLocation;
    }
    if (typeof this.originLocationExternalId !== 'undefined') {
      toReturn['originLocationExternalId'] = this.originLocationExternalId;
    }
    return toReturn;
  }
}
class CreateConversationResponse {
  static fromProto(proto) {
    let m = new CreateConversationResponse();
    m = Object.assign(m, proto);
    if (proto.conversation) {
      m.conversation = Conversation.fromProto(proto.conversation);
    }
    if (proto.participants) {
      m.participants = proto.participants.map(Participant.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversation !== 'undefined' && this.conversation !== null) {
      toReturn['conversation'] = 'toApiJson' in this.conversation ? this.conversation.toApiJson() : this.conversation;
    }
    if (typeof this.participants !== 'undefined' && this.participants !== null) {
      toReturn['participants'] = 'toApiJson' in this.participants ? this.participants.toApiJson() : this.participants;
    }
    return toReturn;
  }
}
class CreateMessageTemplateRequest {
  static fromProto(proto) {
    let m = new CreateMessageTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = MessageTemplate.fromProto(proto.template);
    }
    if (proto.subjectParticipant) {
      m.subjectParticipant = SubjectParticipant.fromProto(proto.subjectParticipant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    if (typeof this.subjectParticipant !== 'undefined' && this.subjectParticipant !== null) {
      toReturn['subjectParticipant'] = 'toApiJson' in this.subjectParticipant ? this.subjectParticipant.toApiJson() : this.subjectParticipant;
    }
    return toReturn;
  }
}
class CreateMessageTemplateResponse {
  static fromProto(proto) {
    let m = new CreateMessageTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = MessageTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class CreateMultiMessagesRequest {
  static fromProto(proto) {
    let m = new CreateMultiMessagesRequest();
    m = Object.assign(m, proto);
    if (proto.messages) {
      m.messages = proto.messages.map(Message.fromProto);
    }
    if (proto.lastSeen) {
      m.lastSeen = new Date(proto.lastSeen);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messages !== 'undefined' && this.messages !== null) {
      toReturn['messages'] = 'toApiJson' in this.messages ? this.messages.toApiJson() : this.messages;
    }
    if (typeof this.lastSeen !== 'undefined' && this.lastSeen !== null) {
      toReturn['lastSeen'] = 'toApiJson' in this.lastSeen ? this.lastSeen.toApiJson() : this.lastSeen;
    }
    return toReturn;
  }
}
class CreateWidgetConversationRequest {
  static fromProto(proto) {
    let m = new CreateWidgetConversationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.chatSourceUrl !== 'undefined') {
      toReturn['chatSourceUrl'] = this.chatSourceUrl;
    }
    return toReturn;
  }
}
class CreateWidgetConversationResponse {
  static fromProto(proto) {
    let m = new CreateWidgetConversationResponse();
    m = Object.assign(m, proto);
    if (proto.conversation) {
      m.conversation = Conversation.fromProto(proto.conversation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetParticipantToken !== 'undefined') {
      toReturn['widgetParticipantToken'] = this.widgetParticipantToken;
    }
    if (typeof this.conversation !== 'undefined' && this.conversation !== null) {
      toReturn['conversation'] = 'toApiJson' in this.conversation ? this.conversation.toApiJson() : this.conversation;
    }
    return toReturn;
  }
}
class CreateWidgetRequest {
  static fromProto(proto) {
    let m = new CreateWidgetRequest();
    m = Object.assign(m, proto);
    if (proto.dataSources) {
      m.dataSources = DataSources.fromProto(proto.dataSources);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.color !== 'undefined') {
      toReturn['color'] = this.color;
    }
    if (typeof this.allowedUrls !== 'undefined') {
      toReturn['allowedUrls'] = this.allowedUrls;
    }
    if (typeof this.welcomeMessage !== 'undefined') {
      toReturn['welcomeMessage'] = this.welcomeMessage;
    }
    if (typeof this.dataSources !== 'undefined' && this.dataSources !== null) {
      toReturn['dataSources'] = 'toApiJson' in this.dataSources ? this.dataSources.toApiJson() : this.dataSources;
    }
    if (typeof this.textColor !== 'undefined') {
      toReturn['textColor'] = this.textColor;
    }
    if (typeof this.accentColor !== 'undefined') {
      toReturn['accentColor'] = this.accentColor;
    }
    if (typeof this.accentTextColor !== 'undefined') {
      toReturn['accentTextColor'] = this.accentTextColor;
    }
    return toReturn;
  }
}
class CreateWidgetResponse {
  static fromProto(proto) {
    let m = new CreateWidgetResponse();
    m = Object.assign(m, proto);
    if (proto.widget) {
      m.widget = Widget.fromProto(proto.widget);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widget !== 'undefined' && this.widget !== null) {
      toReturn['widget'] = 'toApiJson' in this.widget ? this.widget.toApiJson() : this.widget;
    }
    return toReturn;
  }
}
class MetadataDataEntry {
  static fromProto(proto) {
    let m = new MetadataDataEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class DeleteConversationRequest {
  static fromProto(proto) {
    let m = new DeleteConversationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    return toReturn;
  }
}
class DeleteMessageRequest {
  static fromProto(proto) {
    let m = new DeleteMessageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    return toReturn;
  }
}
class DeleteMessageTemplateRequest {
  static fromProto(proto) {
    let m = new DeleteMessageTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class DeleteWidgetRequest {
  static fromProto(proto) {
    let m = new DeleteWidgetRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    return toReturn;
  }
}
class SearchConversationsResponseDetailedConversation {
  static fromProto(proto) {
    let m = new SearchConversationsResponseDetailedConversation();
    m = Object.assign(m, proto);
    if (proto.conversation) {
      m.conversation = Conversation.fromProto(proto.conversation);
    }
    if (proto.latestMessage) {
      m.latestMessage = Message.fromProto(proto.latestMessage);
    }
    if (proto.participants) {
      m.participants = proto.participants.map(Participant.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversation !== 'undefined' && this.conversation !== null) {
      toReturn['conversation'] = 'toApiJson' in this.conversation ? this.conversation.toApiJson() : this.conversation;
    }
    if (typeof this.latestMessage !== 'undefined' && this.latestMessage !== null) {
      toReturn['latestMessage'] = 'toApiJson' in this.latestMessage ? this.latestMessage.toApiJson() : this.latestMessage;
    }
    if (typeof this.participants !== 'undefined' && this.participants !== null) {
      toReturn['participants'] = 'toApiJson' in this.participants ? this.participants.toApiJson() : this.participants;
    }
    return toReturn;
  }
}
class GetMultiConversationDetailsResponseDetailedConversation {
  static fromProto(proto) {
    let m = new GetMultiConversationDetailsResponseDetailedConversation();
    m = Object.assign(m, proto);
    if (proto.conversation) {
      m.conversation = Conversation.fromProto(proto.conversation);
    }
    if (proto.latestMessage) {
      m.latestMessage = Message.fromProto(proto.latestMessage);
    }
    if (proto.participants) {
      m.participants = proto.participants.map(Participant.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversation !== 'undefined' && this.conversation !== null) {
      toReturn['conversation'] = 'toApiJson' in this.conversation ? this.conversation.toApiJson() : this.conversation;
    }
    if (typeof this.latestMessage !== 'undefined' && this.latestMessage !== null) {
      toReturn['latestMessage'] = 'toApiJson' in this.latestMessage ? this.latestMessage.toApiJson() : this.latestMessage;
    }
    if (typeof this.participants !== 'undefined' && this.participants !== null) {
      toReturn['participants'] = 'toApiJson' in this.participants ? this.participants.toApiJson() : this.participants;
    }
    if (typeof this.summary !== 'undefined') {
      toReturn['summary'] = this.summary;
    }
    return toReturn;
  }
}
class EvaluateResponseRequest {
  static fromProto(proto) {
    let m = new EvaluateResponseRequest();
    m = Object.assign(m, proto);
    if (proto.sentiment) {
      m.sentiment = enumStringToValue(EvaluationSentiment, proto.sentiment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    if (typeof this.sentiment !== 'undefined') {
      toReturn['sentiment'] = this.sentiment;
    }
    if (typeof this.comment !== 'undefined') {
      toReturn['comment'] = this.comment;
    }
    return toReturn;
  }
}
class GetAvailableChannelsForConversationRequest {
  static fromProto(proto) {
    let m = new GetAvailableChannelsForConversationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    return toReturn;
  }
}
class GetAvailableChannelsForConversationResponse {
  static fromProto(proto) {
    let m = new GetAvailableChannelsForConversationResponse();
    m = Object.assign(m, proto);
    if (proto.channels) {
      m.channels = proto.channels.map(v => enumStringToValue(ConversationChannel, v));
    }
    if (proto.preferredChannel) {
      m.preferredChannel = enumStringToValue(ConversationChannel, proto.preferredChannel);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.channels !== 'undefined') {
      toReturn['channels'] = this.channels;
    }
    if (typeof this.preferredChannel !== 'undefined') {
      toReturn['preferredChannel'] = this.preferredChannel;
    }
    return toReturn;
  }
}
class GetConfigurationRequest {
  static fromProto(proto) {
    let m = new GetConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.subjectParticipant) {
      m.subjectParticipant = SubjectParticipant.fromProto(proto.subjectParticipant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectParticipant !== 'undefined' && this.subjectParticipant !== null) {
      toReturn['subjectParticipant'] = 'toApiJson' in this.subjectParticipant ? this.subjectParticipant.toApiJson() : this.subjectParticipant;
    }
    return toReturn;
  }
}
class GetConfigurationResponse {
  static fromProto(proto) {
    let m = new GetConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = Configuration.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class GetConversationByKeyRequest {
  static fromProto(proto) {
    let m = new GetConversationByKeyRequest();
    m = Object.assign(m, proto);
    if (proto.conversationKey) {
      m.conversationKey = ConversationKey.fromProto(proto.conversationKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationKey !== 'undefined' && this.conversationKey !== null) {
      toReturn['conversationKey'] = 'toApiJson' in this.conversationKey ? this.conversationKey.toApiJson() : this.conversationKey;
    }
    return toReturn;
  }
}
class GetConversationByKeyResponse {
  static fromProto(proto) {
    let m = new GetConversationByKeyResponse();
    m = Object.assign(m, proto);
    if (proto.conversation) {
      m.conversation = Conversation.fromProto(proto.conversation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversation !== 'undefined' && this.conversation !== null) {
      toReturn['conversation'] = 'toApiJson' in this.conversation ? this.conversation.toApiJson() : this.conversation;
    }
    return toReturn;
  }
}
class GetConversationSummaryRequest {
  static fromProto(proto) {
    let m = new GetConversationSummaryRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    return toReturn;
  }
}
class GetConversationSummaryResponse {
  static fromProto(proto) {
    let m = new GetConversationSummaryResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.summary !== 'undefined') {
      toReturn['summary'] = this.summary;
    }
    return toReturn;
  }
}
class GetConversationViewsRequest {
  static fromProto(proto) {
    let m = new GetConversationViewsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participantId !== 'undefined') {
      toReturn['participantId'] = this.participantId;
    }
    return toReturn;
  }
}
class GetConversationViewsResponse {
  static fromProto(proto) {
    let m = new GetConversationViewsResponse();
    m = Object.assign(m, proto);
    if (proto.views) {
      m.views = proto.views.map(View.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.views !== 'undefined' && this.views !== null) {
      toReturn['views'] = 'toApiJson' in this.views ? this.views.toApiJson() : this.views;
    }
    return toReturn;
  }
}
class GetMessageRequest {
  static fromProto(proto) {
    let m = new GetMessageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    return toReturn;
  }
}
class GetMessageTemplateRequest {
  static fromProto(proto) {
    let m = new GetMessageTemplateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateId !== 'undefined') {
      toReturn['templateId'] = this.templateId;
    }
    return toReturn;
  }
}
class GetMessageTemplateResponse {
  static fromProto(proto) {
    let m = new GetMessageTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = MessageTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class GetMultiConfigurationRequest {
  static fromProto(proto) {
    let m = new GetMultiConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.subjectParticipants) {
      m.subjectParticipants = proto.subjectParticipants.map(SubjectParticipant.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectParticipants !== 'undefined' && this.subjectParticipants !== null) {
      toReturn['subjectParticipants'] = 'toApiJson' in this.subjectParticipants ? this.subjectParticipants.toApiJson() : this.subjectParticipants;
    }
    return toReturn;
  }
}
class GetMultiConfigurationResponse {
  static fromProto(proto) {
    let m = new GetMultiConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.configurations) {
      m.configurations = proto.configurations.map(Configuration.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configurations !== 'undefined' && this.configurations !== null) {
      toReturn['configurations'] = 'toApiJson' in this.configurations ? this.configurations.toApiJson() : this.configurations;
    }
    return toReturn;
  }
}
class GetMultiConversationDetailsRequest {
  static fromProto(proto) {
    let m = new GetMultiConversationDetailsRequest();
    m = Object.assign(m, proto);
    if (proto.options) {
      m.options = FieldMask.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationIds !== 'undefined') {
      toReturn['conversationIds'] = this.conversationIds;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class GetMultiConversationDetailsResponse {
  static fromProto(proto) {
    let m = new GetMultiConversationDetailsResponse();
    m = Object.assign(m, proto);
    if (proto.conversations) {
      m.conversations = proto.conversations.map(GetMultiConversationDetailsResponseDetailedConversation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversations !== 'undefined' && this.conversations !== null) {
      toReturn['conversations'] = 'toApiJson' in this.conversations ? this.conversations.toApiJson() : this.conversations;
    }
    return toReturn;
  }
}
class GetMultiConversationMessageCountRequest {
  static fromProto(proto) {
    let m = new GetMultiConversationMessageCountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationIds !== 'undefined') {
      toReturn['conversationIds'] = this.conversationIds;
    }
    return toReturn;
  }
}
class GetMultiConversationMessageCountResponse {
  static fromProto(proto) {
    let m = new GetMultiConversationMessageCountResponse();
    m = Object.assign(m, proto);
    if (proto.messageCounts) {
      m.messageCounts = proto.messageCounts.map(ConversationMessageCount.fromProto);
    }
    if (proto.counts) {
      m.counts = Object.keys(proto.counts).reduce((obj, k) => {
        obj[k] = parseInt(proto.counts[k], 10);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageCounts !== 'undefined' && this.messageCounts !== null) {
      toReturn['messageCounts'] = 'toApiJson' in this.messageCounts ? this.messageCounts.toApiJson() : this.messageCounts;
    }
    if (typeof this.counts !== 'undefined' && this.counts !== null) {
      toReturn['counts'] = 'toApiJson' in this.counts ? this.counts.toApiJson() : this.counts;
    }
    return toReturn;
  }
}
class GetMultiMessagesRequest {
  static fromProto(proto) {
    let m = new GetMultiMessagesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageIds !== 'undefined') {
      toReturn['messageIds'] = this.messageIds;
    }
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.languageCode !== 'undefined') {
      toReturn['languageCode'] = this.languageCode;
    }
    return toReturn;
  }
}
class GetMultiMessagesResponse {
  static fromProto(proto) {
    let m = new GetMultiMessagesResponse();
    m = Object.assign(m, proto);
    if (proto.messages) {
      m.messages = proto.messages.map(Message.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messages !== 'undefined' && this.messages !== null) {
      toReturn['messages'] = 'toApiJson' in this.messages ? this.messages.toApiJson() : this.messages;
    }
    return toReturn;
  }
}
class GetMultiParticipantsRequest {
  static fromProto(proto) {
    let m = new GetMultiParticipantsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participantIds !== 'undefined') {
      toReturn['participantIds'] = this.participantIds;
    }
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    return toReturn;
  }
}
class GetMultiParticipantsResponse {
  static fromProto(proto) {
    let m = new GetMultiParticipantsResponse();
    m = Object.assign(m, proto);
    if (proto.participants) {
      m.participants = proto.participants.map(Participant.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participants !== 'undefined' && this.participants !== null) {
      toReturn['participants'] = 'toApiJson' in this.participants ? this.participants.toApiJson() : this.participants;
    }
    return toReturn;
  }
}
class GetMultiWidgetMessagesRequest {
  static fromProto(proto) {
    let m = new GetMultiWidgetMessagesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageIds !== 'undefined') {
      toReturn['messageIds'] = this.messageIds;
    }
    return toReturn;
  }
}
class GetMultiWidgetMessagesResponse {
  static fromProto(proto) {
    let m = new GetMultiWidgetMessagesResponse();
    m = Object.assign(m, proto);
    if (proto.messages) {
      m.messages = proto.messages.map(Message.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messages !== 'undefined' && this.messages !== null) {
      toReturn['messages'] = 'toApiJson' in this.messages ? this.messages.toApiJson() : this.messages;
    }
    return toReturn;
  }
}
class GetParticipantsByKeyRequest {
  static fromProto(proto) {
    let m = new GetParticipantsByKeyRequest();
    m = Object.assign(m, proto);
    if (proto.participantKey) {
      m.participantKey = ParticipantKey.fromProto(proto.participantKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participantKey !== 'undefined' && this.participantKey !== null) {
      toReturn['participantKey'] = 'toApiJson' in this.participantKey ? this.participantKey.toApiJson() : this.participantKey;
    }
    return toReturn;
  }
}
class GetParticipantsByKeyResponse {
  static fromProto(proto) {
    let m = new GetParticipantsByKeyResponse();
    m = Object.assign(m, proto);
    if (proto.participants) {
      m.participants = proto.participants.map(Participant.fromProto);
    }
    if (proto.participant) {
      m.participant = Participant.fromProto(proto.participant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participants !== 'undefined' && this.participants !== null) {
      toReturn['participants'] = 'toApiJson' in this.participants ? this.participants.toApiJson() : this.participants;
    }
    if (typeof this.participant !== 'undefined' && this.participant !== null) {
      toReturn['participant'] = 'toApiJson' in this.participant ? this.participant.toApiJson() : this.participant;
    }
    return toReturn;
  }
}
class GetWidgetConfigRequest {
  static fromProto(proto) {
    let m = new GetWidgetConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    return toReturn;
  }
}
class GetWidgetConfigResponse {
  static fromProto(proto) {
    let m = new GetWidgetConfigResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.color !== 'undefined') {
      toReturn['color'] = this.color;
    }
    if (typeof this.isEnabled !== 'undefined') {
      toReturn['isEnabled'] = this.isEnabled;
    }
    if (typeof this.welcomeMessage !== 'undefined') {
      toReturn['welcomeMessage'] = this.welcomeMessage;
    }
    if (typeof this.textColor !== 'undefined') {
      toReturn['textColor'] = this.textColor;
    }
    if (typeof this.accentColor !== 'undefined') {
      toReturn['accentColor'] = this.accentColor;
    }
    if (typeof this.accentTextColor !== 'undefined') {
      toReturn['accentTextColor'] = this.accentTextColor;
    }
    return toReturn;
  }
}
class GetWidgetConversationResponse {
  static fromProto(proto) {
    let m = new GetWidgetConversationResponse();
    m = Object.assign(m, proto);
    if (proto.conversation) {
      m.conversation = Conversation.fromProto(proto.conversation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversation !== 'undefined' && this.conversation !== null) {
      toReturn['conversation'] = 'toApiJson' in this.conversation ? this.conversation.toApiJson() : this.conversation;
    }
    return toReturn;
  }
}
class GetWidgetRequest {
  static fromProto(proto) {
    let m = new GetWidgetRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    return toReturn;
  }
}
class GetWidgetResponse {
  static fromProto(proto) {
    let m = new GetWidgetResponse();
    m = Object.assign(m, proto);
    if (proto.widget) {
      m.widget = Widget.fromProto(proto.widget);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widget !== 'undefined' && this.widget !== null) {
      toReturn['widget'] = 'toApiJson' in this.widget ? this.widget.toApiJson() : this.widget;
    }
    return toReturn;
  }
}
class ListMessageTemplateRequest {
  static fromProto(proto) {
    let m = new ListMessageTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.subjectParticipant) {
      m.subjectParticipant = SubjectParticipant.fromProto(proto.subjectParticipant);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subjectParticipant !== 'undefined' && this.subjectParticipant !== null) {
      toReturn['subjectParticipant'] = 'toApiJson' in this.subjectParticipant ? this.subjectParticipant.toApiJson() : this.subjectParticipant;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListMessageTemplateResponse {
  static fromProto(proto) {
    let m = new ListMessageTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.templates) {
      m.templates = proto.templates.map(MessageTemplate.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templates !== 'undefined' && this.templates !== null) {
      toReturn['templates'] = 'toApiJson' in this.templates ? this.templates.toApiJson() : this.templates;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListMessagesRequestListMessagesFilters {
  static fromProto(proto) {
    let m = new ListMessagesRequestListMessagesFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    return toReturn;
  }
}
class ListMessagesRequest {
  static fromProto(proto) {
    let m = new ListMessagesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListMessagesRequestListMessagesFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListMessagesResponse {
  static fromProto(proto) {
    let m = new ListMessagesResponse();
    m = Object.assign(m, proto);
    if (proto.messages) {
      m.messages = proto.messages.map(Message.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messages !== 'undefined' && this.messages !== null) {
      toReturn['messages'] = 'toApiJson' in this.messages ? this.messages.toApiJson() : this.messages;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListWidgetsRequest {
  static fromProto(proto) {
    let m = new ListWidgetsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListWidgetsResponse {
  static fromProto(proto) {
    let m = new ListWidgetsResponse();
    m = Object.assign(m, proto);
    if (proto.widgets) {
      m.widgets = proto.widgets.map(Widget.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgets !== 'undefined' && this.widgets !== null) {
      toReturn['widgets'] = 'toApiJson' in this.widgets ? this.widgets.toApiJson() : this.widgets;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class LookupConversationsRequestLookupConversationsFilters {
  static fromProto(proto) {
    let m = new LookupConversationsRequestLookupConversationsFilters();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = enumStringToValue(PlatformLocation, proto.location);
    }
    if (proto.channel) {
      m.channel = enumStringToValue(ConversationChannel, proto.channel);
    }
    if (proto.originLocation) {
      m.originLocation = enumStringToValue(PlatformLocation, proto.originLocation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.internalParticipantId !== 'undefined') {
      toReturn['internalParticipantId'] = this.internalParticipantId;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.externalConversationId !== 'undefined') {
      toReturn['externalConversationId'] = this.externalConversationId;
    }
    if (typeof this.originLocation !== 'undefined') {
      toReturn['originLocation'] = this.originLocation;
    }
    if (typeof this.originLocationExternalId !== 'undefined') {
      toReturn['originLocationExternalId'] = this.originLocationExternalId;
    }
    return toReturn;
  }
}
class LookupConversationsRequest {
  static fromProto(proto) {
    let m = new LookupConversationsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = LookupConversationsRequestLookupConversationsFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class LookupConversationsResponse {
  static fromProto(proto) {
    let m = new LookupConversationsResponse();
    m = Object.assign(m, proto);
    if (proto.conversations) {
      m.conversations = proto.conversations.map(LookupConversationsResponseConversations.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversations !== 'undefined' && this.conversations !== null) {
      toReturn['conversations'] = 'toApiJson' in this.conversations ? this.conversations.toApiJson() : this.conversations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class Media {
  static fromProto(proto) {
    let m = new Media();
    m = Object.assign(m, proto);
    if (proto.fileSize) {
      m.fileSize = parseInt(proto.fileSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mediaContentType !== 'undefined') {
      toReturn['mediaContentType'] = this.mediaContentType;
    }
    if (typeof this.mediaLocationPath !== 'undefined') {
      toReturn['mediaLocationPath'] = this.mediaLocationPath;
    }
    if (typeof this.mediaFileName !== 'undefined') {
      toReturn['mediaFileName'] = this.mediaFileName;
    }
    if (typeof this.fileSize !== 'undefined') {
      toReturn['fileSize'] = this.fileSize;
    }
    return toReturn;
  }
}
class Metadata {
  static fromProto(proto) {
    let m = new Metadata();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = enumStringToValue(MetadataIdentifier, proto.identifier);
    }
    if (proto.data) {
      m.data = Object.keys(proto.data).reduce((obj, k) => {
        obj[k] = proto.data[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined') {
      toReturn['identifier'] = this.identifier;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    return toReturn;
  }
}
class ReceiveMessageRequestMetadataEntry {
  static fromProto(proto) {
    let m = new ReceiveMessageRequestMetadataEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ReceiveMessageRequest {
  static fromProto(proto) {
    let m = new ReceiveMessageRequest();
    m = Object.assign(m, proto);
    if (proto.channel) {
      m.channel = enumStringToValue(ConversationChannel, proto.channel);
    }
    if (proto.type) {
      m.type = enumStringToValue(MessageType, proto.type);
    }
    if (proto.location) {
      m.location = enumStringToValue(PlatformLocation, proto.location);
    }
    if (proto.metadata) {
      m.metadata = Object.keys(proto.metadata).reduce((obj, k) => {
        obj[k] = proto.metadata[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.media !== 'undefined') {
      toReturn['media'] = this.media;
    }
    return toReturn;
  }
}
class RemoveConversationFromConversationViewRequest {
  static fromProto(proto) {
    let m = new RemoveConversationFromConversationViewRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.viewId !== 'undefined') {
      toReturn['viewId'] = this.viewId;
    }
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.participantId !== 'undefined') {
      toReturn['participantId'] = this.participantId;
    }
    return toReturn;
  }
}
class SearchConversationsRequest {
  static fromProto(proto) {
    let m = new SearchConversationsRequest();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = enumStringToValue(PlatformLocation, proto.location);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class SearchConversationsResponse {
  static fromProto(proto) {
    let m = new SearchConversationsResponse();
    m = Object.assign(m, proto);
    if (proto.conversations) {
      m.conversations = proto.conversations.map(SearchConversationsResponseDetailedConversation.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversations !== 'undefined' && this.conversations !== null) {
      toReturn['conversations'] = 'toApiJson' in this.conversations ? this.conversations.toApiJson() : this.conversations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class SendMessageRequest {
  static fromProto(proto) {
    let m = new SendMessageRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Participant.fromProto(proto.sender);
    }
    if (proto.recipient) {
      m.recipient = Participant.fromProto(proto.recipient);
    }
    if (proto.type) {
      m.type = enumStringToValue(MessageType, proto.type);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(Metadata.fromProto);
    }
    if (proto.originLocation) {
      m.originLocation = enumStringToValue(PlatformLocation, proto.originLocation);
    }
    if (proto.media) {
      m.media = proto.media.map(Media.fromProto);
    }
    if (proto.channel) {
      m.channel = enumStringToValue(ConversationChannel, proto.channel);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.originLocation !== 'undefined') {
      toReturn['originLocation'] = this.originLocation;
    }
    if (typeof this.media !== 'undefined' && this.media !== null) {
      toReturn['media'] = 'toApiJson' in this.media ? this.media.toApiJson() : this.media;
    }
    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    return toReturn;
  }
}
class SendMessageResponse {
  static fromProto(proto) {
    let m = new SendMessageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.workflowId !== 'undefined') {
      toReturn['workflowId'] = this.workflowId;
    }
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    return toReturn;
  }
}
class SendWidgetMessageRequest {
  static fromProto(proto) {
    let m = new SendWidgetMessageRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(MessageType, proto.type);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(Metadata.fromProto);
    }
    if (proto.location) {
      m.location = enumStringToValue(PlatformLocation, proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    return toReturn;
  }
}
class SendWidgetMessageResponse {
  static fromProto(proto) {
    let m = new SendWidgetMessageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    return toReturn;
  }
}
class SetLastSeenRequest {
  static fromProto(proto) {
    let m = new SetLastSeenRequest();
    m = Object.assign(m, proto);
    if (proto.participant) {
      m.participant = Participant.fromProto(proto.participant);
    }
    if (proto.status) {
      m.status = enumStringToValue(SetLastSeenRequestStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.participant !== 'undefined' && this.participant !== null) {
      toReturn['participant'] = 'toApiJson' in this.participant ? this.participant.toApiJson() : this.participant;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class SetLastSeenResponse {
  static fromProto(proto) {
    let m = new SetLastSeenResponse();
    m = Object.assign(m, proto);
    if (proto.participant) {
      m.participant = Participant.fromProto(proto.participant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.participant !== 'undefined' && this.participant !== null) {
      toReturn['participant'] = 'toApiJson' in this.participant ? this.participant.toApiJson() : this.participant;
    }
    return toReturn;
  }
}
class UpdateConversationRequest {
  static fromProto(proto) {
    let m = new UpdateConversationRequest();
    m = Object.assign(m, proto);
    if (proto.conversation) {
      m.conversation = Conversation.fromProto(proto.conversation);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversation !== 'undefined' && this.conversation !== null) {
      toReturn['conversation'] = 'toApiJson' in this.conversation ? this.conversation.toApiJson() : this.conversation;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateConversationResponse {
  static fromProto(proto) {
    let m = new UpdateConversationResponse();
    m = Object.assign(m, proto);
    if (proto.conversation) {
      m.conversation = Conversation.fromProto(proto.conversation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversation !== 'undefined' && this.conversation !== null) {
      toReturn['conversation'] = 'toApiJson' in this.conversation ? this.conversation.toApiJson() : this.conversation;
    }
    return toReturn;
  }
}
class UpdateMessageStatusRequest {
  static fromProto(proto) {
    let m = new UpdateMessageStatusRequest();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(MessageStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    if (typeof this.participantId !== 'undefined') {
      toReturn['participantId'] = this.participantId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class UpdateMessageTemplateRequest {
  static fromProto(proto) {
    let m = new UpdateMessageTemplateRequest();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = MessageTemplate.fromProto(proto.template);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateMessageTemplateResponse {
  static fromProto(proto) {
    let m = new UpdateMessageTemplateResponse();
    m = Object.assign(m, proto);
    if (proto.template) {
      m.template = MessageTemplate.fromProto(proto.template);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.template !== 'undefined' && this.template !== null) {
      toReturn['template'] = 'toApiJson' in this.template ? this.template.toApiJson() : this.template;
    }
    return toReturn;
  }
}
class UpdateWidgetRequest {
  static fromProto(proto) {
    let m = new UpdateWidgetRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.color !== 'undefined') {
      toReturn['color'] = this.color;
    }
    if (typeof this.allowedUrls !== 'undefined') {
      toReturn['allowedUrls'] = this.allowedUrls;
    }
    if (typeof this.welcomeMessage !== 'undefined') {
      toReturn['welcomeMessage'] = this.welcomeMessage;
    }
    if (typeof this.isEnabled !== 'undefined') {
      toReturn['isEnabled'] = this.isEnabled;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.textColor !== 'undefined') {
      toReturn['textColor'] = this.textColor;
    }
    if (typeof this.accentColor !== 'undefined') {
      toReturn['accentColor'] = this.accentColor;
    }
    if (typeof this.accentTextColor !== 'undefined') {
      toReturn['accentTextColor'] = this.accentTextColor;
    }
    return toReturn;
  }
}
class UpdateWidgetResponse {
  static fromProto(proto) {
    let m = new UpdateWidgetResponse();
    m = Object.assign(m, proto);
    if (proto.widget) {
      m.widget = Widget.fromProto(proto.widget);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widget !== 'undefined' && this.widget !== null) {
      toReturn['widget'] = 'toApiJson' in this.widget ? this.widget.toApiJson() : this.widget;
    }
    return toReturn;
  }
}
class UpsertConfigurationRequest {
  static fromProto(proto) {
    let m = new UpsertConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = Configuration.fromProto(proto.configuration);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpsertConfigurationResponse {
  static fromProto(proto) {
    let m = new UpsertConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = Configuration.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class UpsertProductFeatureRequest {
  static fromProto(proto) {
    let m = new UpsertProductFeatureRequest();
    m = Object.assign(m, proto);
    if (proto.productFeature) {
      m.productFeature = ProductFeature.fromProto(proto.productFeature);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.subjectParticipant) {
      m.subjectParticipant = SubjectParticipant.fromProto(proto.subjectParticipant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productFeature !== 'undefined' && this.productFeature !== null) {
      toReturn['productFeature'] = 'toApiJson' in this.productFeature ? this.productFeature.toApiJson() : this.productFeature;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.subjectParticipant !== 'undefined' && this.subjectParticipant !== null) {
      toReturn['subjectParticipant'] = 'toApiJson' in this.subjectParticipant ? this.subjectParticipant.toApiJson() : this.subjectParticipant;
    }
    return toReturn;
  }
}
class UpsertProductFeatureResponse {
  static fromProto(proto) {
    let m = new UpsertProductFeatureResponse();
    m = Object.assign(m, proto);
    if (proto.productFeature) {
      m.productFeature = ProductFeature.fromProto(proto.productFeature);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productFeature !== 'undefined' && this.productFeature !== null) {
      toReturn['productFeature'] = 'toApiJson' in this.productFeature ? this.productFeature.toApiJson() : this.productFeature;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'conversation-api.vendasta-local.com',
  'test': '',
  'demo': 'conversation-demo.apigateway.co',
  'prod': 'conversation-prod.apigateway.co',
  'production': 'conversation-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ConversationApiService = /*#__PURE__*/(() => {
  class ConversationApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    sendMessage(r) {
      const request = r.toApiJson ? r : new SendMessageRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/SendMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendMessageResponse.fromProto(resp)));
    }
    getMessage(r) {
      const request = r.toApiJson ? r : new GetMessageRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => Message.fromProto(resp)));
    }
    listMessages(r) {
      const request = r.toApiJson ? r : new ListMessagesRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/ListMessages", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMessagesResponse.fromProto(resp)));
    }
    deleteMessage(r) {
      const request = r.toApiJson ? r : new DeleteMessageRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/DeleteMessage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateMessageStatus(r) {
      const request = r.toApiJson ? r : new UpdateMessageStatusRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/UpdateMessageStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    lookupConversations(r) {
      const request = r.toApiJson ? r : new LookupConversationsRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/LookupConversations", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupConversationsResponse.fromProto(resp)));
    }
    getConversationByKey(r) {
      const request = r.toApiJson ? r : new GetConversationByKeyRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetConversationByKey", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConversationByKeyResponse.fromProto(resp)));
    }
    createConversation(r) {
      const request = r.toApiJson ? r : new CreateConversationRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/CreateConversation", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateConversationResponse.fromProto(resp)));
    }
    updateConversation(r) {
      const request = r.toApiJson ? r : new UpdateConversationRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/UpdateConversation", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateConversationResponse.fromProto(resp)));
    }
    deleteConversation(r) {
      const request = r.toApiJson ? r : new DeleteConversationRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/DeleteConversation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    receiveMessage(r) {
      const request = r.toApiJson ? r : new ReceiveMessageRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/ReceiveMessage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiMessages(r) {
      const request = r.toApiJson ? r : new GetMultiMessagesRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetMultiMessages", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiMessagesResponse.fromProto(resp)));
    }
    createMultiMessages(r) {
      const request = r.toApiJson ? r : new CreateMultiMessagesRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/CreateMultiMessages", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiConversationDetails(r) {
      const request = r.toApiJson ? r : new GetMultiConversationDetailsRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetMultiConversationDetails", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiConversationDetailsResponse.fromProto(resp)));
    }
    getMultiParticipants(r) {
      const request = r.toApiJson ? r : new GetMultiParticipantsRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetMultiParticipants", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiParticipantsResponse.fromProto(resp)));
    }
    searchConversations(r) {
      const request = r.toApiJson ? r : new SearchConversationsRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/SearchConversations", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchConversationsResponse.fromProto(resp)));
    }
    getMultiConversationMessageCount(r) {
      const request = r.toApiJson ? r : new GetMultiConversationMessageCountRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetMultiConversationMessageCount", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiConversationMessageCountResponse.fromProto(resp)));
    }
    addMultiParticipants(r) {
      const request = r.toApiJson ? r : new AddMultiParticipantsRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/AddMultiParticipants", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddMultiParticipantsResponse.fromProto(resp)));
    }
    setLastSeen(r) {
      const request = r.toApiJson ? r : new SetLastSeenRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/SetLastSeen", request.toApiJson(), this.apiOptions()).pipe(map(resp => SetLastSeenResponse.fromProto(resp)));
    }
    getParticipantsByKey(r) {
      const request = r.toApiJson ? r : new GetParticipantsByKeyRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetParticipantsByKey", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetParticipantsByKeyResponse.fromProto(resp)));
    }
    getConversationViews(r) {
      const request = r.toApiJson ? r : new GetConversationViewsRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetConversationViews", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConversationViewsResponse.fromProto(resp)));
    }
    addConversationToConversationView(r) {
      const request = r.toApiJson ? r : new AddConversationToConversationViewRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/AddConversationToConversationView", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    removeConversationFromConversationView(r) {
      const request = r.toApiJson ? r : new RemoveConversationFromConversationViewRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/RemoveConversationFromConversationView", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createWidgetConversation(r) {
      const request = r.toApiJson ? r : new CreateWidgetConversationRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/CreateWidgetConversation", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateWidgetConversationResponse.fromProto(resp)));
    }
    getMultiWidgetMessages(r) {
      const request = r.toApiJson ? r : new GetMultiWidgetMessagesRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetMultiWidgetMessages", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiWidgetMessagesResponse.fromProto(resp)));
    }
    sendWidgetMessage(r) {
      const request = r.toApiJson ? r : new SendWidgetMessageRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/SendWidgetMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendWidgetMessageResponse.fromProto(resp)));
    }
    getWidgetConversation() {
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetWidgetConversation", {}, this.apiOptions()).pipe(map(resp => GetWidgetConversationResponse.fromProto(resp)));
    }
    getAvailableChannelsForConversation(r) {
      const request = r.toApiJson ? r : new GetAvailableChannelsForConversationRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetAvailableChannelsForConversation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAvailableChannelsForConversationResponse.fromProto(resp)));
    }
    evaluateResponse(r) {
      const request = r.toApiJson ? r : new EvaluateResponseRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/EvaluateResponse", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createWidget(r) {
      const request = r.toApiJson ? r : new CreateWidgetRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/CreateWidget", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateWidgetResponse.fromProto(resp)));
    }
    getWidget(r) {
      const request = r.toApiJson ? r : new GetWidgetRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetWidget", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWidgetResponse.fromProto(resp)));
    }
    updateWidget(r) {
      const request = r.toApiJson ? r : new UpdateWidgetRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/UpdateWidget", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateWidgetResponse.fromProto(resp)));
    }
    deleteWidget(r) {
      const request = r.toApiJson ? r : new DeleteWidgetRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/DeleteWidget", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listWidgets(r) {
      const request = r.toApiJson ? r : new ListWidgetsRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/ListWidgets", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListWidgetsResponse.fromProto(resp)));
    }
    getWidgetConfig(r) {
      const request = r.toApiJson ? r : new GetWidgetConfigRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetWidgetConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWidgetConfigResponse.fromProto(resp)));
    }
    listMessageTemplate(r) {
      const request = r.toApiJson ? r : new ListMessageTemplateRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/ListMessageTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListMessageTemplateResponse.fromProto(resp)));
    }
    deleteMessageTemplate(r) {
      const request = r.toApiJson ? r : new DeleteMessageTemplateRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/DeleteMessageTemplate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createMessageTemplate(r) {
      const request = r.toApiJson ? r : new CreateMessageTemplateRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/CreateMessageTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateMessageTemplateResponse.fromProto(resp)));
    }
    updateMessageTemplate(r) {
      const request = r.toApiJson ? r : new UpdateMessageTemplateRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/UpdateMessageTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateMessageTemplateResponse.fromProto(resp)));
    }
    getMessageTemplate(r) {
      const request = r.toApiJson ? r : new GetMessageTemplateRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetMessageTemplate", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMessageTemplateResponse.fromProto(resp)));
    }
    getConversationSummary(r) {
      const request = r.toApiJson ? r : new GetConversationSummaryRequest(r);
      return this.http.post(this._host + "/conversation.v1.ConversationService/GetConversationSummary", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConversationSummaryResponse.fromProto(resp)));
    }
  }
  ConversationApiService.ɵfac = function ConversationApiService_Factory(t) {
    return new (t || ConversationApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ConversationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConversationApiService,
    factory: ConversationApiService.ɵfac,
    providedIn: 'root'
  });
  return ConversationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let InboxApiService = /*#__PURE__*/(() => {
  class InboxApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getConfiguration(r) {
      const request = r.toApiJson ? r : new GetConfigurationRequest(r);
      return this.http.post(this._host + "/conversation.v1.InboxService/GetConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConfigurationResponse.fromProto(resp)));
    }
    getMultiConfiguration(r) {
      const request = r.toApiJson ? r : new GetMultiConfigurationRequest(r);
      return this.http.post(this._host + "/conversation.v1.InboxService/GetMultiConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiConfigurationResponse.fromProto(resp)));
    }
    upsertConfiguration(r) {
      const request = r.toApiJson ? r : new UpsertConfigurationRequest(r);
      return this.http.post(this._host + "/conversation.v1.InboxService/UpsertConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpsertConfigurationResponse.fromProto(resp)));
    }
    upsertProductFeature(r) {
      const request = r.toApiJson ? r : new UpsertProductFeatureRequest(r);
      return this.http.post(this._host + "/conversation.v1.InboxService/UpsertProductFeature", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpsertProductFeatureResponse.fromProto(resp)));
    }
  }
  InboxApiService.ɵfac = function InboxApiService_Factory(t) {
    return new (t || InboxApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  InboxApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InboxApiService,
    factory: InboxApiService.ɵfac,
    providedIn: 'root'
  });
  return InboxApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AddConversationToConversationViewRequest, AddMultiParticipantsRequest, AddMultiParticipantsResponse, Address, Configuration, Conversation, ConversationApiService, ConversationChannel, ConversationKey, ConversationMessageCount, CreateConversationRequest, CreateConversationResponse, CreateMessageTemplateRequest, CreateMessageTemplateResponse, CreateMultiMessagesRequest, CreateWidgetConversationRequest, CreateWidgetConversationResponse, CreateWidgetRequest, CreateWidgetResponse, DataSources, DeleteConversationRequest, DeleteMessageRequest, DeleteMessageTemplateRequest, DeleteWidgetRequest, EvaluateResponseRequest, EvaluationSentiment, FieldMask, GetAvailableChannelsForConversationRequest, GetAvailableChannelsForConversationResponse, GetConfigurationRequest, GetConfigurationResponse, GetConversationByKeyRequest, GetConversationByKeyResponse, GetConversationSummaryRequest, GetConversationSummaryResponse, GetConversationViewsRequest, GetConversationViewsResponse, GetMessageRequest, GetMessageTemplateRequest, GetMessageTemplateResponse, GetMultiConfigurationRequest, GetMultiConfigurationResponse, GetMultiConversationDetailsRequest, GetMultiConversationDetailsResponse, GetMultiConversationDetailsResponseDetailedConversation, GetMultiConversationMessageCountRequest, GetMultiConversationMessageCountResponse, GetMultiConversationMessageCountResponseCountsEntry, GetMultiMessagesRequest, GetMultiMessagesResponse, GetMultiParticipantsRequest, GetMultiParticipantsResponse, GetMultiWidgetMessagesRequest, GetMultiWidgetMessagesResponse, GetParticipantsByKeyRequest, GetParticipantsByKeyResponse, GetWidgetConfigRequest, GetWidgetConfigResponse, GetWidgetConversationResponse, GetWidgetRequest, GetWidgetResponse, GlobalParticipantType, InboxApiService, LastSeenByParticipant, ListMessageTemplateRequest, ListMessageTemplateResponse, ListMessagesRequest, ListMessagesRequestListMessagesFilters, ListMessagesResponse, ListWidgetsRequest, ListWidgetsResponse, LookupConversationsRequest, LookupConversationsRequestLookupConversationsFilters, LookupConversationsResponse, LookupConversationsResponseConversations, Media, Message, MessageStatus, MessageTemplate, MessageType, Metadata, MetadataDataEntry, MetadataIdentifier, NamespaceDetail, PagedRequestOptions, PagedResponseMetadata, Participant, ParticipantKey, ParticipantMessageStatus, ParticipantType, PlatformLocation, ProductFeature, ReceiveMessageRequest, ReceiveMessageRequestMetadataEntry, RemoveConversationFromConversationViewRequest, SearchConversationsRequest, SearchConversationsResponse, SearchConversationsResponseDetailedConversation, SendMessageRequest, SendMessageResponse, SendStatus, SendWidgetMessageRequest, SendWidgetMessageResponse, SetLastSeenRequest, SetLastSeenRequestStatus, SetLastSeenResponse, SortDirection, SubjectParticipant, UpdateConversationRequest, UpdateConversationResponse, UpdateMessageStatusRequest, UpdateMessageTemplateRequest, UpdateMessageTemplateResponse, UpdateWidgetRequest, UpdateWidgetResponse, UpsertConfigurationRequest, UpsertConfigurationResponse, UpsertProductFeatureRequest, UpsertProductFeatureResponse, View, ViewType, Widget, WidgetPosition };
